import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export default function getDefaultListViewType(config) {
    if (isConsumer()) {
        var globalFolderViewState = config.ViewStateConfiguration.GlobalFolderViewState;
        if (globalFolderViewState && !JSON.parse(globalFolderViewState).IsConversationView) {
            return 1 /* Message */;
        }
        return 0 /* Conversation */;
    }
    var folderViewState = config.ViewStateConfiguration.FolderViewState;
    var inboxId = folderNameToId('inbox');
    // default to conversation view in case of missing info
    if (!inboxId || !folderViewState || !folderViewState.length) {
        return 0 /* Conversation */;
    }
    var inboxEntry = folderViewState.filter(function (folder) { return JSON.parse(folder).FolderId.Id === inboxId; });
    var listViewType = inboxEntry && inboxEntry.length && inboxEntry[0]
        ? JSON.parse(inboxEntry[0]).View
        : 1;
    return listViewType === 1 ? 0 /* Conversation */ : 1 /* Message */;
}
//# sourceMappingURL=getDefaultListViewType.js.map